const IMAGE_TEMPLATE_CACHE_INVALIDATED_EVENT = 'dobi:image-template-cache-invalidated';

type ImageTemplateCacheInvalidatedDetail = {
  templateId?: string;
};

export function dispatchImageTemplateCacheInvalidated(templateId?: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<ImageTemplateCacheInvalidatedDetail>(
    IMAGE_TEMPLATE_CACHE_INVALIDATED_EVENT,
    { detail: templateId ? { templateId } : {} },
  ));
}

export function listenForImageTemplateCacheInvalidation(
  handler: (templateId?: string) => void,
): () => void {
  if (typeof window === 'undefined') return () => {};
  const listener = (event: Event) => {
    const detail = event instanceof CustomEvent
      ? (event.detail as ImageTemplateCacheInvalidatedDetail | undefined)
      : undefined;
    handler(detail?.templateId);
  };
  window.addEventListener(IMAGE_TEMPLATE_CACHE_INVALIDATED_EVENT, listener);
  return () => window.removeEventListener(IMAGE_TEMPLATE_CACHE_INVALIDATED_EVENT, listener);
}

